import { render } from "./SideBar.vue?vue&type=template&id=a45f175c"
import script from "./SideBar.vue?vue&type=script&lang=js"
export * from "./SideBar.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\david\\Documents\\Dada\\Omnichannel-Dada\\dashboard-agente\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__